<script setup lang="ts">
import { useUserData } from '~/composables/account/use-user-data'

const config = useRuntimeConfig()
const { currentUser } = useUserData()
const { EVENT_PREMIER_LEAGUE_RANKING_ENABLED } = config.public

const hasMinigame = ref(false)
const { isMobile } = useDevice()

const isPosition = computed((): string => {
  if(EVENT_PREMIER_LEAGUE_RANKING_ENABLED) {
    return isMobile ? 'auto 20px 400px auto' : '30% 20px auto auto'
  }
  return isMobile ? 'auto 20px 300px auto' : '42% 20px auto auto'
})

useHead({ script: [{ src: 'https://assets.vgjt.info/js/mn.js', type: 'module', crossorigin: '' }] })

watch(() => currentUser.value.gptoken, () => {
  hasMinigame.value = false
  nextTick(() => hasMinigame.value = true)
})

onMounted(() => hasMinigame.value = true)
</script>

<template>
  <c2-minigame
    v-if="hasMinigame"
    :pos="isPosition"
    :token="currentUser.gptoken"
    :partner="config.public.BRAND_CODE"
  />
</template>

<style lang="scss">
c2-minigame > div > div {
  z-index: 500 !important;
}
</style>
